<template> 
	<!-- Main content Start -->
	<div class="main">
		<HomeContent :isMobile="true"></HomeContent>
	</div>
	<!-- Main content End -->
</template>

<script>
// @ is an alias to /src
import HomeContent from '@/components/HomeContent.vue'

export default {
	components: {
		HomeContent,
	},
	data() {
		return {
		}
	},
	mounted() {
	    window.getSessionFromMobile = this.getSessionFromMobile
	    document.title = 'Home'
		this.$store.commit('setBackTo', 'HomeMobile');
	},
	methods: {
		getSessionFromMobile(loggedSessionID, isTrainer, loggedUserPlan, loggedUserID) {
			this.$store.commit("set", {
				loggedSessionID: loggedSessionID,
				isTrainer: isTrainer,
				loggedUserPlan: loggedUserPlan,
				loggedUserID: loggedUserID,
			});
	    }
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  min-height: 100vh;
}
</style>